import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Form_carriers from "./Form_carriers";
import Header from "./Header";
import Loader from "./Loader";
import Form_carriers_pfe from "./Form_carriers_pfe";

const Pfebook = () => {
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        {/*=================================
page-title*/}

        {/*=================================
page-title */}
        {/*=================================
 careers*/}
        <section
          className="careers white-bg page-section-ptb"
          style={{ paddingTop: "170px" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="section-title text-center">
                  <h6></h6>
                  <h2 className="title-effect">Projet PFE</h2>
                  <p className></p>
                </div>
              </div>
            </div>
            <div>
              <div>
                {/** */}
                <div className="accordion shadow">
                  {/**Model

                  <div className="acd-group acd-active">
                    <a className="acd-heading" href="#">
                      PFE-01: Application de dimensionnement d'un
                      transformateurAMIN
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department : </b>IT{" "}
                          </span>
                          <span>
                            <b>Objectif : </b>L'objectif principal du projet est
                            de développer une application capable de
                            dimensionner des transformateurs électriques tout en
                            optimisant les coûts associés. Cette application
                            vise à être un outil intuitif pour les ingénieurs,
                            facilitant la prise de décision technique.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Les objectif de l’application{" "}
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Concevoir une
                              application capable de :
                            </li>
                            <li>
                              -Dimensionner un transformateur en fonction des
                              paramètres fournis (puissance, tension, fréquence,
                              etc.).
                            </li>
                            <li>
                              -Calculer les pertes et l'efficacité énergétique.
                            </li>
                            <li>
                              -Optimiser les coûts, incluant les coûts d'achat,
                              d'installation et d'exploitation.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Fournir une
                              interface utilisateur intuitive et ergonomique.{" "}
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Intégrer des
                              fonctionnalités de simulation pour comparer
                              différentes configurations
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Générer des
                              rapports automatisés.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Générer des
                              plans de fabrication des semis finis.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Partie fonctionnel
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Saisie des
                              paramètres techniques du transformateur
                              (puissance, tension primaire et secondaire, type
                              d'utilisation, etc.).
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />{" "}
                              Dimensionnement automatique en fonction des normes
                              et des contraintes imposées.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Calcul des
                              coûts d’investissement et d’exploitation.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Comparaison de
                              plusieurs scénarios
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Propositions
                              d’alternatives optimales pour réduire les coûts.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Analyse des
                              pertes (fer, cuivre, charge partielle, etc.).
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            CV à l'adresse e-mail suivante :
                          </p>
                          <a href="mailto:recrutement@sacemgroup.com">
                            recrutement@sacemgroup.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  */}
                  {/**1er pfe */}
                  <div className="acd-group acd-active">
                    <a className="acd-heading" href="#">
                      PFE-01: Plateforme Intelligente
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department : </b>IT{" "}
                          </span>
                          <span>
                            <b>Objectif : </b>Le projet vise à développer une
                            plateforme intelligente de suivi, d’analyse et de
                            prédiction du prix des principales matières
                            premières utilisées dans la fabrication des
                            transformateurs électriques.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Les objectif de la plateforme{" "}
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Prédiction du
                              prix des principales matières premières:
                            </li>
                            <li>• Cuivre.</li>
                            <li>• Tôle magnétique.</li>
                            <li>• Huile minérale isolante.</li>
                            <li>
                              <i className="fa fa-angle-right" /> Suivre en
                              temps réel l’évolution des prix.{" "}
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Visualiser les
                              tendances de prix (graphiques, indicateurs,
                              historiques.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Prévoir les
                              tendances futures.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Recommander le
                              meilleur moment d’achat.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Générer des
                              rapports automatiques pour le service achat et la
                              direction.
                            </li>
                          </ul>
                        </div>
                        {/** 
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Partie fonctionnel
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Saisie des
                              paramètres techniques du transformateur
                              (puissance, tension primaire et secondaire, type
                              d'utilisation, etc.).
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />{" "}
                              Dimensionnement automatique en fonction des normes
                              et des contraintes imposées.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Calcul des
                              coûts d’investissement et d’exploitation.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Comparaison de
                              plusieurs scénarios
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Propositions
                              d’alternatives optimales pour réduire les coûts.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Analyse des
                              pertes (fer, cuivre, charge partielle, etc.).
                            </li>
                          </ul>
                        </div>
                        */}
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            candidature et CV dans le formulaire ci-dessous.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**2eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="#">
                      PFE-02: Prédiction des conceptions de transformateurs
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> IT{" "}
                          </span>
                          <span>
                            <b>Objectif: </b>L’entreprise souhaite mettre en
                            place un système intelligent capable de prédire les
                            conceptions optimales de transformateurs électriques
                            en fonction des spécifications techniques, des
                            contraintes de production et des données
                            historiques.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Les objectif de l’application
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Réduire le
                              temps de conception.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Optimiser les
                              coûts et la performance des transformateurs.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Exploiter les
                              données historiques pour anticiper les besoins et
                              améliorer la qualité.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Fonctionnalités Attendues
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Module de
                              prédiction : proposer une conception optimale
                              (dimensions, matériaux, coûts).
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Simulation :
                              évaluer la performance des conceptions proposées.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Tableau de bord : suivi des prédictions,
                              indicateurs de performance.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Exportation : génération automatique de fiches
                              techniques.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            candidature et CV dans le formulaire ci-dessous.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**3eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="#">
                      PFE-03: Système Intelligent de Suivi des Appels d’Offres
                      et Opportunités Commerciales
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> IT{" "}
                          </span>
                          <span>
                            <b>Objectif: </b>
                          </span>
                          <p>
                            - Surveiller automatiquement les appels d’offres
                            internationaux pour la vente de transformateurs de
                            distribution.
                          </p>
                          <p>
                            - Identifier les financements ou fonds ouverts sur
                            les projets d’électricité dans le monde.
                          </p>
                          <p>
                            - Détecter et signaler les opportunités commerciales
                            stratégiques pour l’entreprise.
                          </p>
                          <p>
                            - Fournir des recommandations pour le meilleur
                            moment pour soumettre une offre ou engager des
                            négociations.
                          </p>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Fonctionnalités principales
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Collecte des
                              données
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Suivi des
                              financements
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Détection des
                              opportunités commerciales
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Analyse et
                              prédiction
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Alertes et
                              notifications
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Interface
                              utilisateur
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Intelligence
                              artificielle
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Fonctionnalités Attendues
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Gagner du
                              temps et de la réactivité sur les appels d’offres
                              internationaux.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Prioriser les
                              opportunités financées et rentables.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Détecter et exploiter les opportunités
                              commerciales stratégiques.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Optimiser la stratégie commerciale grâce à des
                              recommandations basées sur l’IA.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Centraliser toutes les informations sur les
                              projets d’électricité dans le monde.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            candidature et CV dans le formulaire ci-dessous.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**4eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="">
                      PFE-04: Mise en place d’un système SPC (Statistical
                      Process Control)
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> Méthodes{" "}
                          </span>
                          <span>
                            <b>Objectif: </b>Le projet consiste à concevoir et à
                            mettre en œuvre un système de contrôle statistique
                            de processus (SPC) pour un processus de production
                            afin de l'optimiser et améliorer ses performances.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Etapes de projet
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />
                              <b> Analyse du processus de fabrication:</b>
                              <p>• Etude détaillée des étapes de production.</p>
                              <p>
                                • Identification des paramètres critiques
                                affectant les caractéristiques intrinsèques et
                                la qualité du produit.
                              </p>
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              <b> Collecte et traitement des données :</b>
                              <p>
                                • Mesure systématique des paramètres critiques à
                                l’aide d’instruments de précision.
                              </p>
                              <p>
                                • Compilation des données pour chaque lot afin
                                d’établir une base statistique fiable.
                              </p>
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              <b>Implémentation du SPC :</b>
                              <p>
                                • Sélection des outils statistiques appropriés :
                                cartes de contrôle (X-bar, R, P), histogrammes
                                et diagrammes de Pareto.
                              </p>
                              <p>
                                • Définition des limites de contrôle et des
                                seuils d’alerte pour chaque paramètre critique.
                              </p>
                              <p>
                                • Surveillance continue des lots afin de
                                détecter les variations anormales et d’anticiper
                                les défauts.
                              </p>
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              <b> Analyse et amélioration continue :</b>
                              <p>
                                • Identification des causes racines des écarts
                                par rapport aux limites de contrôle.
                              </p>
                              <p>
                                • Proposition de mesures correctives pour
                                réduire la variabilité du processus.
                              </p>
                              <p>
                                • Optimisation du processus de fabrication afin
                                d’améliorer la qualité globale et de réduire les
                                rebuts et les retouches.
                              </p>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Résultats attendus :
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Cartes de
                              contrôle et tableaux de suivi opérationnels pour
                              la production.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Réduction des
                              défauts et des rebuts dans la fabrication des
                              circuits magnétiques.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Documentation complète du processus SPC pour une
                              application future sur d’autres sections de
                              l’usine.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            candidature et CV dans le formulaire ci-dessous.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**5eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="">
                      PFE-05: Etude AMDEC Processus
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> Méthodes{" "}
                          </span>
                          <span>
                            <b>Objectif: </b>Le projet consiste à réaliser une
                            étude AMDEC Processus de production afin
                            d’identifier, d’évaluer et de hiérarchiser les
                            risques de défaillance pouvant affecter la qualité
                            et la fiabilité des produits finis.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Objectifs du projet:
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />
                              Identifier et hiérarchiser les risques dans le
                              processus de production.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Réduire les défaillances et améliorer la fiabilité
                              des produits fabriqués.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Proposer des actions correctives pour sécuriser et
                              optimiser le processus.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Contribuer à la mise en place d’une démarche
                              qualité proactive dans la production.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Etapes de projet
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />
                              Analyse du processus de production.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Identification des modes de défaillance.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Évaluation de la criticité.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Propositions d’actions correctives et préventives.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Documentation et recommandations.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Résultats attendus :
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Tableau AMDEC
                              complet avec les modes de défaillance, causes,
                              effets et indices de criticité.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Plan d’action
                              pour réduire les risques prioritaires.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Amélioration de la qualité et de la fiabilité du
                              processus.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Documentation formalisée pouvant servir de
                              référence pour l’audit interne ou la certification
                              qualité de l’usine.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            candidature et CV dans le formulaire ci-dessous.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**6eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="">
                      PFE-06: Conception et réalisation d'une machine de
                      production des traverses en bois
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> Méthodes{" "}
                          </span>
                          <span>
                            <b>Objectif: </b>Le projet consiste en la conception
                            et la réalisation d’une machine automatisée destinée
                            à la production en continu de pièces en bois
                            comportant des rainures, trous et découpes.
                            L’équipement doit être conçu pour recevoir des bruts
                            de bois d’une longueur maximale de 6 m et d’en
                            assurer l’usinage complet conformément aux
                            instructions d’un programme CNC.
                          </span>
                          <br />
                          <h4 className="mb-20 theme-color">
                            <b>
                              La machine intègre plusieurs modules fonctionnels
                              permettant d’assurer une chaîne d’usinage
                              continue:
                            </b>
                          </h4>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color"></h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />
                              Un automate programmable (PLC) assurant le
                              contrôle centralisé des opérations, la
                              coordination des actionneurs, ainsi que la gestion
                              des séquences d’usinage selon les paramètres
                              définis dans le programme CNC.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Une unité de perçage ø22 mm, dédiée à la
                              réalisation des trous de fixation ou d’assemblage,
                              avec un positionnement précis assuré par le
                              système de commande.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Une mortaiseuse, permettant de créer des rainures
                              ou mortaises avec une précision constante sur la
                              longueur de la pièce.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Une scie de découpe finale, destinée à tronçonner
                              la pièce une fois l’ensemble des opérations
                              d’usinage terminé.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            L’ensemble est conçu pour garantir une production
                            fluide, répétitive et conforme aux exigences de
                            qualité, tout en optimisant les temps d’usinage et
                            en réduisant les interventions manuelles. Ce projet
                            met en œuvre des compétences en automatisation
                            industrielle, en mécanique, en programmation CNC et
                            en intégration de systèmes, afin de proposer une
                            solution complète pour la fabrication de pièces en
                            bois usinées de manière continue et fiable.
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            candidature et CV dans le formulaire ci-dessous.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/** */}
              </div>
              <div style={{ paddingTop: "20px" }}>
                <Form_carriers_pfe />
              </div>
            </div>
          </div>
        </section>
        {/*=================================
 careers*/}
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Pfebook;
